import { generatePath } from 'react-router-dom'
import { COMPETITOR_SPIKE_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Target2 } from 'blaze-ui/icons/20'

interface Props {
  workspaceId: number
  onPress: () => void
}

export const NavMenuCompetitorAnalysisItem = ({ workspaceId, onPress }: Props) => {
  const to = generatePath(COMPETITOR_SPIKE_PATH, { workspaceId })

  return <NavMenuItem icon={Target2} activeIcon={Target2} to={to} onPress={onPress} label="Competitor Analysis" />
}
